import Client from '../../../model/api/Client';
import React, { useCallback, useState } from 'react';
import { Step1 } from './parts/Step1';
import { Step2 } from './parts/Step2';

interface IProps {
	defaultSlug: string;
	apiClient: Client;
	codexUrl: string;
	companyName: string;
}

export const Form = ({ defaultSlug, apiClient, codexUrl, companyName }: IProps): React.ReactNode => {
	const [step, setStep] = useState<number>(1);
	const [slug, setSlug] = useState<string>(defaultSlug);
	const [email, setEmail] = useState<string>('');

	const onSubmitEmail = useCallback(
		(e: string, s: string) => {
			setEmail(e);
			setSlug(s);
			setStep(2);
		},
		[setEmail, setStep]
	);

	if (step === 1) {
		return <Step1 onSuccess={onSubmitEmail} apiClient={apiClient} defaultSlug={slug} companyName={companyName} />;
	}

	return <Step2 slug={slug} apiClient={apiClient} email={email} codexUrl={codexUrl} />;
};
